module.exports = __webpack_public_path__ + "static/media/dishwasher.21eb349b.svg";